import type {MessageDescriptor} from 'react-intl';
import {MAX_PLACES} from '../utils/constants';

const getPlacesLabel = (
    searchResultCount: number | null,
    formatMessage: (
        messageDescriptor: MessageDescriptor,
        values?: Record<string, any>
    ) => string
) => {
    const messageDescriptor = {
        id: 'placesFilterLabel',
        defaultMessage:
            '{resultsCount, plural, zero {places} one {place} few {places} many {places} other {places}}',
        description: 'Label for the amount of places to display',
    };

    return formatMessage(messageDescriptor, {resultsCount: searchResultCount});
};

export const getFormattedResults = (
    searchResultCount: number,
    formatMessage: (
        messageDescriptor: MessageDescriptor,
        values?: Record<string, any>
    ) => string
) => {
    const searchResultCountDisplay =
        searchResultCount >= MAX_PLACES ? MAX_PLACES : searchResultCount;
    const isMaxMoreThanAllowedPlaces = searchResultCount > MAX_PLACES;

    return `${searchResultCountDisplay}${
        isMaxMoreThanAllowedPlaces ? '+' : ''
    } ${getPlacesLabel(searchResultCount, formatMessage)}`;
};
